const disableDefaults = function (ed) {
	// ADG3 UX includes new shortcuts which are defined in shortcut-definition.js.
	// As part of this change some old shortcuts are removed, this file disables shortcuts registered with window.tinymce.
	// ed.shortcuts.remove() returns TRUE on remove success.
	// https://pug.jira-dev.com/wiki/spaces/FE/pages/edit/2386395164?draftId=2389180435&draftShareId=c2940524-947f-429f-a1aa-ccf38c959853&
	const result = {
		// mac
		'meta+Alt+0': ed.shortcuts.remove('meta+Alt+0'),
		'meta+Alt+1': ed.shortcuts.remove('meta+Alt+1'),
		'meta+Alt+2': ed.shortcuts.remove('meta+Alt+2'),
		'meta+Alt+3': ed.shortcuts.remove('meta+Alt+3'),
		'meta+Alt+4': ed.shortcuts.remove('meta+Alt+4'),
		'meta+Alt+5': ed.shortcuts.remove('meta+Alt+5'),
		'meta+Alt+6': ed.shortcuts.remove('meta+Alt+6'),
		'meta+Alt+7': ed.shortcuts.remove('meta+Alt+7'),
		'meta+Alt+8': ed.shortcuts.remove('meta+Alt+8'),
		'meta+s': ed.shortcuts.remove('meta+s'), // Publish
		'meta+shift+i': ed.shortcuts.remove('meta+shift+i'), // disable insert table

		'meta+shift+x': ed.shortcuts.remove('meta+shift+x'), // disable cut table
		'meta+shift+c': ed.shortcuts.remove('meta+shift+c'), // disable copy table
		'meta+shift+v': ed.shortcuts.remove('meta+shift+v'), // disable paste table
		'ctrl+shift+M': ed.shortcuts.remove('ctrl+shift+M'), // disable inline attachment browser
		'ctrl+F': ed.shortcuts.remove('ctrl+F'), // disable Find & Replace
		'meta+shift+n': ed.shortcuts.remove('meta+shift+n'), // disable numbered list
		'meta+shift+b': ed.shortcuts.remove('meta+shift+b'), // disable bullet list

		'access+0': ed.shortcuts.remove('access+0'),
		'access+1': ed.shortcuts.remove('access+1'),
		'access+2': ed.shortcuts.remove('access+2'),
		'access+3': ed.shortcuts.remove('access+3'),
		'access+4': ed.shortcuts.remove('access+4'),
		'access+5': ed.shortcuts.remove('access+5'),
		'access+6': ed.shortcuts.remove('access+6'),
		'access+7': ed.shortcuts.remove('access+7'),
		'access+8': ed.shortcuts.remove('access+8'),
		'access+9': ed.shortcuts.remove('access+9'),

		// windows
		'alt+arrowUp': ed.shortcuts.remove('alt+38'), // disable insert Row Before
		'alt+arrowDown': ed.shortcuts.remove('alt+40'), // disable insert Row After

		'ctrl+f': ed.shortcuts.remove('ctrl+f'), // disable search
		'ctrl+shift+n': ed.shortcuts.remove('ctrl+shift+n'), // disable numbered list
		'ctrl+shift+b': ed.shortcuts.remove('ctrl+shift+b'), // disable bullet list

		'ctrl+shift+I': ed.shortcuts.remove('ctrl+shift+I'), // disable insert table
		'ctrl+0': ed.shortcuts.remove('ctrl+0'),
		'ctrl+1': ed.shortcuts.remove('ctrl+1'),
		'ctrl+2': ed.shortcuts.remove('ctrl+2'),
		'ctrl+3': ed.shortcuts.remove('ctrl+3'),
		'ctrl+4': ed.shortcuts.remove('ctrl+4'),
		'ctrl+5': ed.shortcuts.remove('ctrl+5'),
		'ctrl+6': ed.shortcuts.remove('ctrl+6'),
		'ctrl+7': ed.shortcuts.remove('ctrl+7'),
		'ctrl+8': ed.shortcuts.remove('ctrl+8'),
		'ctrl+s': ed.shortcuts.remove('ctrl+s'), // Publish
	};
	// result returns the outcome of unbinding shortcuts, true for success
	// depending on the OS, some key combos will return false because its not bound for that OS.
	return result;
};

export default disableDefaults;
